import {
    FETCH_SONG_RELEASE_DATA_REQUEST,
    FETCH_SONG_RELEASE_DATA_SUCCESS,
    FETCH_SONG_RELEASE_DATA_FAILURE
} from "./songReleaseTypes";
const initialState = {
    loading: false,
    releaseSongList: [],
    error: '',
  }
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case   FETCH_SONG_RELEASE_DATA_REQUEST:
        return {
          ...state,
          loading: true
        }
      case FETCH_SONG_RELEASE_DATA_SUCCESS:
        console.log("aaaaaaaaaaaa", action.payload)
        return {
          ...state,
          loading: false,
          releaseSongList: action.payload,
          error: ''
        }
      case FETCH_SONG_RELEASE_DATA_FAILURE:
        return {
          ...state,
          loading: false,
          releaseSongList: [],
          error: action.payload
        }
       
      default: return state
    }
  }
  
  export default reducer